<template>
  <div>
    <span class="sr-only">{{ label }}</span>
    <svg :width="width" :height="height" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
      <path
        v-if="includeText"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7679 40C16.1162 40 17.0837 39.2908 17.2503 37.8886H16.2193C16.1082 38.712 15.5531 39.1196 14.7679 39.1196C13.7598 39.1196 13.1561 38.4014 13.1128 37.1762L13.1103 36.9674C13.1103 35.663 13.7606 34.8641 14.7599 34.8641C15.5768 34.8641 15.9972 35.2636 16.1162 36.038H17.1869C17.06 34.6685 16.0527 34 14.752 34C13.1737 34 11.9999 35.2228 11.9999 36.9755V37.0408C11.9999 38.8342 12.9913 40 14.7679 40ZM18.1558 39.9187H19.2107V37.7013H20.0038C21.1739 37.7013 22.0195 37.1934 22.0784 36.0534L22.0817 35.8915C22.0817 34.6686 21.2489 34.0898 19.98 34.0898H18.1558V39.9187ZM19.2106 34.9293V36.9185H19.9799C20.6779 36.9185 21.0506 36.5679 21.0506 35.9239L21.0473 35.7854C21.0081 35.1708 20.6186 34.9293 19.9799 34.9293H19.2106ZM22.9792 39.9187H24.034V37.5627H24.7081L26.1912 39.9187H27.3333L25.7392 37.3996C26.4097 37.2215 26.9443 36.7932 26.9961 35.968L27.0002 35.8018C27.0002 34.6116 26.1278 34.0898 24.8826 34.0898H22.9792V39.9187ZM24.034 34.9293V36.788H24.8826C25.5885 36.788 25.9612 36.4782 25.9612 35.8587V35.8261C25.9612 35.1576 25.5567 34.9293 24.8826 34.9293H24.034Z"
        :fill="fillColor"
      />
      <path
        d="M16.9081 16.9649L17.5841 15.3723L19.9734 20.454L21.9517 16.8181L22.5534 18.4065H25.1103C25.3865 18.4065 25.6103 18.1826 25.6103 17.9065C25.6103 17.6303 25.3865 17.4065 25.1103 17.4065H23.2439L22.1149 14.426L20.0384 18.2421L17.5374 12.923L16.2462 15.9649H14.3418C14.0657 15.9649 13.8418 16.1887 13.8418 16.4649C13.8418 16.741 14.0657 16.9649 14.3418 16.9649H16.9081Z"
        :fill="fillColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0001 32C28.8366 32 36.0001 24.8366 36.0001 16C36.0001 7.16344 28.8366 0 20.0001 0C11.1635 0 4.00006 7.16344 4.00006 16C4.00006 24.8366 11.1635 32 20.0001 32ZM20.0061 13.5129C20.0061 10.9469 17.9492 8.86651 15.4282 8.86651C12.9072 8.86651 10.863 10.9469 10.863 13.5129V13.8653C10.863 19.0097 19.7169 24.5377 20.0061 24.5377C20.2953 24.5377 29.1492 19.0097 29.1492 13.8653V13.5129C29.1492 10.9469 27.1049 8.86651 24.5839 8.86651C22.063 8.86651 20.0061 10.9469 20.0061 13.5129Z"
        :fill="fillColor"
      />
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CPRBadge',
  props: {
    width: {
      type: Number,
      default: 40,
    },
    height: {
      type: Number,
      default: 40,
    },
    active: {
      type: Boolean,
      default: true,
    },
    hasSimpleLabel: {
      type: Boolean,
      default: false,
    },
    includeText: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    fillColor(): string {
      return this.color || (this.active ? '#BB0049' : '#B4B5B7');
    },
    label() {
      if (this.hasSimpleLabel) {
        return 'CPR training';
      }

      return `This user ${this.active ? 'has' : 'does not have'} CPR training`;
    },
  },
};
</script>
